import React from "react";
import './DailyBitcoin.css';
import ContestMenu from "./ContestMenu/ContestMenu";
import ContestRegistration from "./ContestRegistration/Registration";
import Open02Prize from "../../../static/img/Trader/ContestAll/ContestPrizes.svg";
import LayoutMain from "../../00LayoutMain/LayoutMain";
import SendQuestion from "../../00LayoutMain/TopMenu/SendQuestion/SendQuestion";
import QueryContestInfo from "./QueryContestInfo/QueryContestInfo";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";


    function GatsbyContestDailyBitcoinSource (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        const MenuTop = [{Link : '',Name : props.PrerenderTexts['DailyBitcoin0080'] ? JSON.parse(props.PrerenderTexts['DailyBitcoin0080'])[props.lang] : '*Все конкурсы'},
        {Link : '/dailybitcoinnow/',Name : props.PrerenderTexts['DailyBitcoin0085'] ?  JSON.parse(props.PrerenderTexts['DailyBitcoin0085'])[props.lang] : '*Текущая торговля'},
        {Link : '/result/',Name : props.PrerenderTexts['DailyBitcoin0090'] ?  JSON.parse(props.PrerenderTexts['DailyBitcoin0090'])[props.lang] : '*Результаты прошлых'},
        {Link : '/prizes/',Name : props.PrerenderTexts['DailyBitcoin0095'] ?  JSON.parse(props.PrerenderTexts['DailyBitcoin0095'])[props.lang] : '*Получить приз'},
    ];
    return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang} Active={1}>
            <main className="DailyBitcoin StandartPage">
                <div className="StandartNOTitle"/>
                <div className="StandartWhitePart">
                    <div className="StandartWhitePartTitle">
                        <div className="StandartWhitePartTitleText"><TextSource ArrIndex= 'DailyBitcoin0007'>Конкурс "Ты и Биткоин"</TextSource> </div>
                        <SendQuestion lang={props.lang}/>
                    </div>
                    <ContestMenu lang={props.lang} Menu={MenuTop}/>
                    <div className="DailyBitcoinTop StandartIn">
                        <div className="DailyBitcoinTopBanner"/>
                        <div className="DailyBitcoinTopRight">
                        <div className="DailyBitcoinTopIn">
                            <div className="DailyBitcoinTopTitle"><TextSource ArrIndex= 'DailyBitcoin0010'>Условия конкурса</TextSource> </div>
                            <div className="DailyBitcoinTopLi">
                                <div className="DailyBitcoinTopLiElement">
                                    <div className="DailyBitcoinTopLiElementDot"/>
                                    <div className="DailyBitcoinTopLiElementText"><TextSource ArrIndex= 'DailyBitcoin0015'>Участие в конкурсе платное и стоит 1$</TextSource>  </div>
                                </div>
                                <div className="DailyBitcoinTopLiElement">
                                    <div className="DailyBitcoinTopLiElementDot"/>
                                    <div className="DailyBitcoinTopLiElementText"><TextSource ArrIndex= 'DailyBitcoin0020'>Множественная регистрация разрешена</TextSource>  </div>
                                </div>
                                <div className="DailyBitcoinTopLiElement">
                                    <div className="DailyBitcoinTopLiElementDot"/>
                                    <div className="DailyBitcoinTopLiElementText"><TextSource ArrIndex= 'DailyBitcoin0025'>Конкурс проводится еженедельно</TextSource>  </div>
                                </div>
                            </div>
                            <QueryContestInfo lang={props.lang}/>

                            <div className="DailyBitcoinTopBottom">
                                <TextSource ArrIndex= 'DailyBitcoin0040'>Внимание! Время по GMT (в терминале вы можете установить любое время)</TextSource>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="DailyBitcoinText StandartIn">
                        <TextSource ArrIndex= 'DailyBitcoin0045'>Каждому участнику на счет поступает 5000$. Плечо 1:200. Место распределяется согласно заработку за день. 51 призовое место. Размер призового фонда — это взносы участников. Побеждает самый прибыльный.</TextSource>
                    </div>
                    <div className="DailyBitcoinTitle StandartIn"><TextSource ArrIndex= 'DailyBitcoin0046'>Правила</TextSource> </div>
                    <div className="DailyBitcoinText StandartIn">
                        <TextSource ArrIndex= 'DailyBitcoin0050'>Все действия по каждому конкурсному счету видны в таблице. Вы можете зайти на счет любого участника и посмотреть ордера во время конкурса. Далее ордера стейтмент счета доступен в истории конкурсов.</TextSource>
                    <p/>
                        <TextSource ArrIndex= 'DailyBitcoin0055'>Просьба обратить внимание: Регистрация проходит на текущий конкурс. Мы рекомендуем регистрироваться не поздней 12:00 GMT</TextSource>
                    </div>
                    <div className="DailyBitcoinAllPrizes">
                    <div className="StandartIn">
                    <div className="DailyBitcoinAllPrizesIn">
                    <div className="DailyBitcoinAllPrizesInIn">
                        <div className="DailyBitcoinAllPrizesTitle">
                            <b><TextSource ArrIndex= 'DailyBitcoin0060'>Распределение призов</TextSource> </b>
                            <TextSource ArrIndex= 'DailyBitcoin0065'>(призовой фонд составляет 100%)</TextSource></div>
                        <div className="DailyBitcoinAllPrizesInfo">
                            <div className="DailyBitcoinAllPrizesInfoTitle"> <TextSource ArrIndex= 'DailyBitcoin0070'>Место</TextSource></div>
                            <div className="DailyBitcoinAllPrizesInfoElement"> 1</div>
                            <div className="DailyBitcoinAllPrizesInfoElement"> 2</div>
                            <div className="DailyBitcoinAllPrizesInfoElement"> 3</div>
                            <div className="DailyBitcoinAllPrizesInfoElement"> 4</div>
                            <div className="DailyBitcoinAllPrizesInfoElement"> 5-19</div>
                            <div className="DailyBitcoinAllPrizesInfoElement"> 20-170</div>
                        </div>
                        <div className="DailyBitcoinAllPrizesPrize">
                            <div className="DailyBitcoinAllPrizesInfoTitle"><TextSource ArrIndex= 'DailyBitcoin0075'>Приз</TextSource></div>
                            <div className="DailyBitcoinAllPrizesPrizeElement"> 100$</div>
                            <div className="DailyBitcoinAllPrizesPrizeElement"> 60$</div>
                            <div className="DailyBitcoinAllPrizesPrizeElement"> 50$</div>
                            <div className="DailyBitcoinAllPrizesPrizeElement"> 40$</div>
                            <div className="DailyBitcoinAllPrizesPrizeElement"> 10$</div>
                            <div className="DailyBitcoinAllPrizesPrizeElement"> 1$</div>

                        </div>
                    </div><img alt='alt' src={Open02Prize} width="96px" height="105px"/>
                    </div>

                    </div>

                    </div>

                    <ContestRegistration  lang={props.lang} ContestName={'DailyBitcoin'}/>
                </div>


            </main>

        </LayoutMain>








)}

export default GatsbyContestDailyBitcoinSource